import eventMixin from '../lib/eventMixin';
import KeenSlider from 'keen-slider';
import Logger from "../utilities/Logger";

const paginationDotActiveClass = 'theme-block-full-width-banner-slideshow__pagination-dot--active';

export default class ThemeBlockFullWidthProjectSlideshow {

		constructor(dom) {
				this.NAME = 'ThemeBlockFullWidthProjectSlideshow';
				Logger.log(`${this.NAME} > initializing…`);
				// Vars
				// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
				const self          = this;
				this.dom            = dom;
				this.arrowNext      = this.dom.querySelector('[data-theme-block-full-width-banner-slideshow-show-next]');// Set up the slideshow
				this.arrowPrev      = this.dom.querySelector('[data-theme-block-full-width-banner-slideshow-show-prev]');
				this.pagination     = this.dom.querySelector('[data-theme-block-full-width-banner-slideshow-pagination]');
				this.paginationDots = this.dom.querySelectorAll('[data-theme-block-full-width-banner-slide-show]');
				this.slideshow      = null;
				this.slides         = this.dom.querySelectorAll('[data-theme-block-full-width-banner-slide]');

				/**
				 * Listen for a focused event, and then initialize the slideshow (once)
				 */
				self.on('focused', () => {
						this.init();
				});

				/**
				 * this.observer --- Create an Observer. Initialize the slider when it's actually visible on the page.
				 * @type {IntersectionObserver}
				 */
				this.observer = new IntersectionObserver((entries) => {

						// Check for the intersecting item
						entries.forEach((entry) => {
								if (entry.isIntersecting) {
										entry.target.setAttribute('data-is-visible', 'true');
										Logger.log(`${self.NAME} > IntersectionObserver > focused…`);
										self.trigger("focused", entry.target);
								} else {
										entry.target.removeAttribute('data-is-visible');
										Logger.log(`${self.NAME} > IntersectionObserver > blurred…`);
										self.trigger("blurred", entry.target);
								}
						});
						this.trigger("updated");
				}, {
						threshold: .01,
				});
				this.observer.observe(this.dom);
		}

		init() {
				const self = this;

				// Set up the slideshow
				if (!this.slideshow) {

						// Initialize Keen
						this.slideshow = new KeenSlider(this.dom, {
								selector: this.slides,
								loop: true,
								created: () => {
										Logger.log(`${self.NAME} > Created`);
										self.trigger('created');

										// We have to wait a bit because the this.slideshow var is not
										// immediately available since we are in the created event still
										setTimeout(() => {
												self.adjustClasses();
										}, 100);
								},
								destroyed: () => {
										Logger.log(`${self.NAME} > Destroyed`);
										self.trigger('destroyed');
								},
								slideChanged: () => {
										Logger.log(`${self.NAME} > slideChanged`);
										self.adjustClasses();
								},
						});

						// Initialize pagination dots
						this.paginationDots.forEach((dot) => {
								dot.addEventListener('click', (evt) => {
										const idx = dot.getAttribute('data-theme-block-full-width-banner-slide-show');
										Logger.log(`${self.NAME} > this.paginationDots > Pagination dot was clicked, adjusting slideshow to slide ${idx}`);
										self.slideshow.moveToIdx(idx * 1);
								});
						});

						// Initialize arrows
						this.arrowNext.addEventListener('click', (evt) => {
								self.slideshow.next();
						});
						this.arrowPrev.addEventListener('click', (evt) => {
								self.slideshow.prev();
						});
				}
		}

		adjustClasses() {
				const activeSlide = this.slideshow.track.details.rel;

				if (this.paginationDots && this.paginationDots[activeSlide]) {
						this.paginationDots.forEach((dot) => {
								dot.classList.remove(paginationDotActiveClass);
								dot.setAttribute('aria-selected', 'false');
						});
						this.paginationDots[activeSlide].classList.add(paginationDotActiveClass);
						this.paginationDots[activeSlide].setAttribute('aria-selected', 'true');
				}
		}

}

// Mixins
Object.assign(ThemeBlockFullWidthProjectSlideshow.prototype, eventMixin);
